<template>
    <ul class="conf-agenda-dates list-none flex p-0 flex-col lg:flex-row w-full no-print clean-list">
        <li class="flex-grow">
            <a href="#" @click.prevent="dateClicked('')" :class="buttonClasses('')">All Days</a>
        </li>
        <li v-for="date in availableDates" :key="date.date" class="flex-grow">
            <a href="#" @click.prevent="dateClicked(date.date)" :class="buttonClasses(date.date)">{{ date.formattedDate }}</a>
        </li>
    </ul>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters(["availableDates"]),
        ...mapState(["agenda"])
    },
    methods: {
        ...mapMutations(["setActiveDate", "toggleCollapseAll"]),
        dateClicked(date) {
            this.toggleCollapseAll(true);
            this.setActiveDate(date)
        },
        buttonClasses(date) {
            const allButtons =
                "w-full inline-block p-5 border border-dividers text-center uppercase font-semibold hover:bg-midwinter-blue hover:text-white";

            const finalButtons =
                date == this.agenda.activeDate
                    ? "bg-midwinter-blue text-white " + allButtons
                    : "bg-white text-midwinter-blue " + allButtons;

            return finalButtons;
        }
    }
};
</script>

<style>
    ul.conf-agenda-dates li a:hover {
        color: white !important;
    }
    ul.conf-agenda-dates li a:focus {
        color: white !important;
    }
    ul.conf-agenda-dates li a {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 130%;
        text-align: center;
        text-decoration: none;
        padding: 19px;
    }

</style>



// WEBPACK FOOTER //
// src/js/vue-components/conference-agenda/ConfAgendaDates.vue